/**
 * Styled Components - Created by david on 09/04/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import AntdIcon from 'antd/lib/icon'
import {
  BLUE,
  WHITE,
  GRAY_DARK
} from '../../theme/colors'
import { AVENIR_NEXT } from '../../theme/fonts'

interface DivProps {
  width?: string
  left?: boolean
  value?: string
  secondary?: boolean
}

export const Container = styled.div`
  background-color: #fff;
  padding: 20px 32px 90px 32px;
  max-width: 1024px;
  margin: 0 auto;
  width: 100%;
  font-family: Avenir;
  @media (min-width: 320px) and (max-width: 480px) {
    padding: 20px 10px 90px 10px;
  }
`

export const DescDiv = styled.div``

export const StepContainer = styled.div`
  border: 1px solid #D7D1D2;
  margin-top: 30px;
  padding: 16px;
  border-radius: 8px;
  font-family: "Avenir Next";
  @media (max-width: 698px) {
    margin-top: 16px;
  }
  h1 {
    color: #302628;
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 0;
  }
  h6 {
    color: #302628;
    font-size: 14px;
    font-weight: 500;
    line-height: 140%;
  }
  input {
    border-radius: 8px;
    border: 1px solid ##D9D9D9;
    background: #FFFFFF;
    color: #5F6062;
    font-size: 14px;
    line-height: 140%;
  }
  .margin-top {
    margin-top: 30px;
    @media (min-width: 320px) and (max-width: 698px) {
      margin-top: 20px;
    }
  }
`

export const Subtitle = styled.div`
  color: #5f6062;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  padding: 16px 0;
`

export const Message = styled.div`
  color: #5f6062;
  font-size: 14px;
  line-height: 23px;
`

export const PriceMessage = styled.div`
  color: #5f6062;
  font-size: 16px;
  line-height: 23px;
`

export const DragMessage = styled.p`
  color: #5f6062;
  padding: 4px 0px;
  font-size: 16px;
  line-height: 22px;
`
export const TextBlock = styled.div`
  margin: 18px 0;
  margin-top: ${({ secondary }: DivProps) => secondary ? '-10px' : '18px'};
`

export const DragTypes = styled.p`
  color: #bebebe;
  font-size: 13px;
  line-height: 18px;
`

export const Icon = styled.img`
  margin-bottom: 8px;
`

export const PreviewImage = styled.img`
  width: 100%;
  max-width: 1452px;
  max-height: 300px;
  object-fit: cover;
  margin: 0 auto;
  display: block;
  margin-bottom: 16px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 320px) and (max-width: 480px) {
    flex-direction: column;
    align-items: start;
  }
`

export const RowButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-bottom: 16px;
  }
`

export const ButtonDelete = styled.div`
  color: #e61737;
  font-size: 14px;
  line-height: 19px;
  margin-left: 8px;
  cursor: pointer;
`

export const RowColumn = styled.div`
  display: flex;
  flex-flow: column;
  textarea {
    height: 38px;
    border-radius: 8px;
    border: 1px solid #D9D9D9;
    padding: 12px 16px;
  }
  @media (max-width: 480px) {
    width: 100%;
    textarea {
      height: 68px;
    }
  }
`

export const AddButtons = styled.div`
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
  }
`

export const AddItem = styled(Button)`
  padding: 4px 30px;
  margin: 16px 0px;
  margin-right: 26px;
  border-radius: 22px;
  border: 1.5px solid #302628 !important;
  background: #302628 !important;
  color: ${WHITE} !important;
  font-size: 14px;
  font-weight: 600;
  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
  }
  &:hover {
    background: white !important;
    color: #302628 !important;
  }
`

export const AddItemInline = styled(Button)`
  padding: 4px 40px;
  border-radius: 22px;
  border: 1.5px solid #131112 !important;
  transition: all .25s;
  color: #302628 !important;
  font-size: 14px;
  font-weight: 600;
  &:hover {
    background: #302628 !important;
    color: white !important;
  }
`

export const ButtonOptionsWrapper = styled.div`
  position: fixed;
  bottom: 0;
  background: white;
  width: 100%;
  left: 0;
  text-align: right;
  border: 1px solid #D7D1D2;
  padding: 8px 74px;
  z-index: 2;
  @media (max-width: 698px) {
    padding: 8px 12px;
  }
`

export const ButtonOptionStyle = styled(Button)`
  width: 100%;
  max-width: 184px;
  color: #302628;
  border-radius: 25px;
  border-color: #302628;
  margin-right: 20px;
  font-size: 14px;
  &:hover {
    color: white;
    background: #302628;
    border-color: #302628;
  }
  @media (max-width: 698px) {
    max-width: 134px;
  }
  @media (max-width: 360px) {
    margin-right: 10px;
    max-width: 100px;
  }
`
export const SaveButton = styled(Button)`
  width: 100%;
  max-width: 222px;
  color: white;
  background: #302628;
  border-radius: 25px;
  border-color: #302628;
  font-size: 14px;
  &:hover {
    color: #302628;
    background: white;
    border-color: #302628;
  }
  @media (max-width: 698px) {
    max-width: 200px;
  }
  @media (max-width: 360px) {
    max-width: 182px;
  }
`

export const draggerStyle = { padding: '30px 0px', marginBottom: 16 }

export const BulletinLabel = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  @media (max-width: 480px) {
    flex-flow: column;
    align-items: flex-start;
  }
`

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  align-items: center;
`

export const DynamicDropLogo = styled.img`
  width: 150px;
  margin: 15px 0;
  border-radius: 4px;
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const buttonStyle = {
  background: BLUE,
  border: 'none'
}

export const SuccessIcon = styled(AntdIcon)`
  color: green;
  margin-right: 16px;
`

export const DescriptionDesktop = styled.div`
  display: block;
  margin: auto 20px;
  #qtyLink {
    line-height: 1.5;
    color: cornflowerblue;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
  }
  @media (max-width: 698px) {
    display: none;
  }
`

export const DescriptionMobile = styled.div`
  display: none;
  #qtyLink {
    line-height: 1.5;
    color: cornflowerblue;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
  }
  @media (max-width: 698px) {
    display: block;
    margin-top: 16px;
  }
`

export const ModalTitleContainer = styled.div`
  display: flex;
  align-items: center;
`

export const BulkShipTagIconMargin = styled.div`
  margin-right: 16px;
`

export const EnabledTag = styled.div`
  margin-left: 14px;
  background: #d8f4b3;
  padding: 0px 8px;
  border-radius: 3px;
  font-size: 14px;
  @media (max-width: 698px) {
    margin-left: 0;
    align-self: flex-end;
  }
`

export const BulkBody = styled.div`
  margin-top: -8px;
  margin-bottom: -28px;
`

export const ConfirmButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .ant-btn-primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }

  .ant-btn:hover {
    color: #4a90e2;
    border-color: #4a90e2;
  }

  .ant-btn-primary:hover {
    color: #fff;
    background-color: #6ea6e7;
    border-color: #6ea6e7;
  }
`

export const BulkShipTagIcon = styled.img`
  width: 30px;
`

export const BulkShipping = styled.div`
  display: flex;
  flex-flow: column;
  padding: 16px;
  border: 1px solid #D7D1D2;
  border-radius: 8px;
  margin-top: 30px;
  @media (max-width: 698px) {
    padding: 18px;
    margin-top: 16px;
  }
  #bulkDesc {
    background: #F5EDCC;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
  }
  #bulkSub {
    font-size: 16px;
    font-weight: 500;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .radioBulk {
    display: flex;
    margin-top: 12px;
    color: #302628;
    input {
      accent-color: black;
      height: 16px;
      width: 16px;
      margin-right: 10px;
      margin-top: 1px;
    }
    .disabled {
      color: #8F8889;
    }
  }
  #bulkAddressDet {
    margin-top: 42px;
    border-radius: 0 8px 8px 8px;
    border: 1.5px solid #F5EDCC;
    padding: 12px 14px;
    position: relative;
  }
  #headerAddress {
    position: absolute;
    bottom: 100%;
    background: #F5EDCC;
    font-weight: bold;
    left: -1px;
    padding: 4px 10px;
    border-radius: 8px 8px 0 0;
    font-size: 12px;
  }
`

export const ActionButton = styled.div`
  border: 1.5px solid #302628;
  color: #302628;
  padding: 10px;
  width: 100%;
  max-width: 366px;
  margin-top: 28px;
  text-align: center;
  border-radius: 25px;
  font-weight: 500;
  border-radius: 25px;
  transition: background-color .25s, color .25s;
  &:hover {
    background-color: #302628;
    color: white;
    cursor: pointer;
  }
`

export const BannerStyleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 30px;
  font-family: "Avenir Next";
  &.is-disabled {
    opacity: 0.45;
    pointer-events: none;
  }
  .banner-style-header {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    font-size: 14px;
    line-height: 1.4;
  }
  .banner-style-title {
    color: #302628;
    font-weight: 500;
  }
  .banner-style-hint {
    color: #817e7e;
    font-weight: 400;
  }
  .banner-style-options {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .banner-style-option {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: fit-content;
    input {
      accent-color: #302628;
      height: 20px;
      width: 20px;
      margin: 0 10px 0 0;
      flex-shrink: 0;
    }
    span {
      color: #302628;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
    }
  }
  @media (max-width: 698px) {
    margin-top: 20px;
  }
`

export const BannerStyleSample = styled.img`
  width: 100%;
  padding: 2px;
  background: white;
`

export const ShippingContainer = styled.div`
  .editAddr {
    display: none;
  }
  #shippingContainer {
    margin-top: 0px;
  }
  #titleShip {
    font-weight: bold;
    font-size: 18px;
  }
`

export const StyledSwitch = styled.label`
  margin-top: var(--spacing-12);
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  .ant-switch-checked {
    background-color: var(--series-pro);
  }
  @media (max-width: 767px) {
    align-items: flex-start;
    .ant-switch {
      margin-top: 2px;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/CreateStore/styledComponents.tsx